// Contract addresses on Optimism Sepolia Testnet
export const CONTRACT_ADDRESSES = {
  OPTIMISM_SEPOLIA: {


    CEL_TOKEN: "0x000F12aB9DD46000B3592661405e19a65f34b743",
    PROTOCOL_TREASURY: "0xa5E82a8A6E368AeAa95a03EbE24F84C04610bD87",
    INNOVATION_UNITS: "0x41978B967EEaB25021d9F8959556CCefE5BE9A15",
    PROJECT_STAKING: "0x9849B211383d0228765296fDC80070a5133FE0D3",
    EMISSION_CONTROLLER: "0x9B7aE154fc49712cA017429A19F16A1132980843"
  },
  // Optimism Mainnet (to be updated with real addresses when deployed)
  OPTIMISM: {
    CEL_TOKEN: "0x0c3dCa7865203A9bbdC83942a3f1B1567D331Aa6", // Placeholder - replace with real address
    PROTOCOL_TREASURY: "0x1e4255cF5B0703f5479cEC16f97a31ec9831c728", // Placeholder
    INNOVATION_UNITS: "0xAC6c3dA6dCdF275E08A2cC45B01c6AABa79C5225", // Placeholder
    PROJECT_STAKING: "0x1ADF945Dc0a33589D5E8C1Ad769fea6842117409", // Placeholder
    EMISSION_CONTROLLER: "0x13d90E0Df5eaCE296481B76F01b24c942Eb1f48C" // Placeholder
  },
  // Local development network
  LOCALHOST: {
    CEL_TOKEN: "0xc6e7DF5E7b4f2A278906862b61205850344D4e7d",
    PROTOCOL_TREASURY: "0x59b670e9fA9D0A427751Af201D676719a970857b",
    INNOVATION_UNITS: "0x4ed7c70F96B99c776995fB64377f0d4aB3B0e1C1",
    PROJECT_STAKING: "0x322813Fd9A801c5507c9de605d63CEA4f2CE6c44",
    EMISSION_CONTROLLER: "0xa85233C63b9Ee964Add6F2cffe00Fd84eb32338f"
  }
};

// Supported networks configuration
export const SUPPORTED_NETWORKS = {
  OPTIMISM_SEPOLIA: {
    chainId: 11155420,
    chainIdHex: '0xaa37dc',
    name: 'Optimism Sepolia',
    currency: {
      name: 'Sepolia Ether',
      symbol: 'ETH',
      decimals: 18
    },
    rpcUrls: ['https://sepolia.optimism.io'],
    blockExplorerUrls: ['https://sepolia-optimism.etherscan.io/'],
    iconUrl: 'https://optimism.io/images/favicon.ico'
  },
  OPTIMISM: {
    chainId: 10,
    chainIdHex: '0xa',
    name: 'Optimism Mainnet',
    currency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18
    },
    rpcUrls: ['https://mainnet.optimism.io'],
    blockExplorerUrls: ['https://optimistic.etherscan.io/'],
    iconUrl: 'https://optimism.io/images/favicon.ico'
  },
  
};

// Network switching parameters
export const NETWORK_PARAMS = {
  OPTIMISM_SEPOLIA: {
    chainId: '0xaa37dc', // 11155420 in hexadecimal
    chainName: 'Optimism Sepolia',
    nativeCurrency: {
      name: 'Sepolia Ether',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://sepolia.optimism.io'],
    blockExplorerUrls: ['https://sepolia-optimism.etherscan.io/'],
  },
  OPTIMISM: {
    chainId: '0xa', // 10 in hexadecimal
    chainName: 'Optimism Mainnet',
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://mainnet.optimism.io'],
    blockExplorerUrls: ['https://optimistic.etherscan.io/'],
  }
};

// Default network ID
export const DEFAULT_NETWORK = 'OPTIMISM_SEPOLIA';

// Function to get contract addresses for the current network
export const getContractAddresses = (chainId) => {
  switch (chainId) {
    case 11155420:
      return CONTRACT_ADDRESSES.OPTIMISM_SEPOLIA;
    case 10:
      return CONTRACT_ADDRESSES.OPTIMISM;
    case 31337:
      return CONTRACT_ADDRESSES.LOCALHOST;
    default:
      console.warn(`No contract addresses defined for chainId: ${chainId}`);
      return null;
  }
};

// Function to get network name from chainId
export const getNetworkName = (chainId) => {
  switch (chainId) {
    case 11155420:
      return 'OPTIMISM_SEPOLIA';
    case 10:
      return 'OPTIMISM';
    case 31337:
      return 'LOCALHOST';
    default:
      return 'UNSUPPORTED_NETWORK';
  }
};

// Function to check if a network is supported
export const isNetworkSupported = (chainId) => {
  return getNetworkName(chainId) !== 'UNSUPPORTED_NETWORK';
};

// Common ABIs for common functions
export const COMMON_ABIS = {
  ERC20: [
    'function balanceOf(address owner) view returns (uint256)',
    'function decimals() view returns (uint8)',
    'function symbol() view returns (string)',
    'function name() view returns (string)',
    'function totalSupply() view returns (uint256)',
    'function transfer(address to, uint amount) returns (bool)',
    'function approve(address spender, uint256 amount) returns (bool)',
    'function allowance(address owner, address spender) view returns (uint256)',
    'event Transfer(address indexed from, address indexed to, uint amount)'
  ]
}; 